import ObjectEncoder from './cookies/objectEncoder';

export interface CookieAttributes {
    /** Expiration time in seconds | Expiration date */
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean;
    /**
     * Encodes one dimensional objects or arrays in a simple way to reduce cookie size
     * - JSON.parse vs simple encode:
     * {%220%22:1%2C%221%22:0%2C%222%22:0} vs o|0:1|1:1|2:0
     */
    objectEncode?: boolean;
}

/**
 * @link https://github.com/js-cookie/js-cookie
 */
export default class AitiCoreCookies {

    get(name: string, objectDecode: boolean = false): string[] | object | string | null {
        let value = Cookies.get(name);

        if (typeof value === 'string' && objectDecode) {
            try {
                value = ObjectEncoder.decode(value);
            } catch {
                return null;
            }
        }

        return value ?? null;
    }

    set(name: string, value: any, attributes: CookieAttributes = {}) {
        if (typeof attributes.expires === 'number') {
            attributes.expires = new Date(Date.now() + attributes.expires * 1000);
        }

        if (typeof attributes.path === 'undefined') {
            attributes.path = '/';
        }

        if (typeof attributes.domain === 'undefined') {
            attributes.domain = location.hostname;
        }

        if (typeof attributes.secure === 'undefined') {
            attributes.secure = true;
        }

        if (attributes?.objectEncode && typeof value === 'object') {
            value = ObjectEncoder.encode(value);
        }

        Cookies.set(name, value, attributes);
    }

    exists(name: string): boolean {
        return typeof Cookies.get(name) !== 'undefined';
    }

    remove(name: string) {
        Cookies.remove(name);
    }
}
